import { render, staticRenderFns } from "./formDialog.vue?vue&type=template&id=3849912c&scoped=true"
import script from "./formDialog.vue?vue&type=script&lang=js"
export * from "./formDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849912c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3849912c')) {
      api.createRecord('3849912c', component.options)
    } else {
      api.reload('3849912c', component.options)
    }
    module.hot.accept("./formDialog.vue?vue&type=template&id=3849912c&scoped=true", function () {
      api.rerender('3849912c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/formDialog.vue"
export default component.exports